// General
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // General variables
  gameTitle: "gaming.sugarbook_casino",
  isGameOpen: false,
  selectedGameUrl: null,
  isExtendedGame: false,

  // Utility variables
  gameListPassthrough: null,
};

export const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    // General Functions
    updateGameTitle: (state, action) => {
      state.gameTitle = action.payload;
    },
    resetGameTitle: (state) => {
      state.gameTitle = "gaming.sugarbook_casino";
    },
    updateIsGameOpen: (state) => {
      state.isGameOpen = !state.isGameOpen;
    },
    updateSelectedGame: (state, action) => {
      state.selectedGameUrl = action.payload?.initiate_endpoint;
      state.isExtendedGame = !!action.payload?.extended;
    },
    resetSelectedGameUrl: (state) => {
      state.selectedGameUrl = null;
      state.isExtendedGame = false;
    },

    // Utility Functions
    resetGameStore: () => {
      return { ...initialState };
    },
    updateGameListPassthrough: (state) => {
      state.gameListPassthrough = {};
    },
  },
});

export const {
  updateGameTitle,
  resetGameTitle,
  updateIsGameOpen,
  updateSelectedGame,
  resetSelectedGameUrl,

  // Utility Functions
  resetGameStore,
  updateGameListPassthrough,
} = gameSlice.actions;

export default gameSlice.reducer;
